// @flow
import * as React from 'react';
import { Portal, useSaveAgentGmailCodeMutation } from '../../shared';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getRoute } from '../../app/router';
import { Preloader } from '@coverright/features';
import { useEffect } from 'react';
import { Breadcrumbs, Container, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';

export const GmailVerificationCode = () => {
  const [saveCode] = useSaveAgentGmailCodeMutation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has('code')) {
      saveCode({variables: {code: urlParams.get('code') as string}}).then(() => navigate(getRoute('integrations')))
    } else {
      navigate(getRoute('integrations'))
    }
  }, [location, saveCode, navigate])

  return <Container maxWidth={'sm'} sx={{mt: 2}}>
    <Breadcrumbs aria-label="breadcrumb">
      <MuiLink component={Link}
               underline="hover" color="inherit"
               to={`/${getRoute('profile')}`}>
        Settings
      </MuiLink>
      <Typography>Integrations</Typography>
    </Breadcrumbs>

    <Divider sx={{mb: 2, mt: 1}} />

    <Stack gap={3}>
      <Typography variant="subtitle1">Integrations</Typography>

      <Portal p={2}>
        <img src={'/assets/gmail-logo.jpg'} width={100} height={'auto'} />

        <Divider sx={{my: 2, mx: -2}} />

        <Preloader sx={{ minHeight: 100 }} />
      </Portal>

    </Stack>
  </Container>
}
